import { ReportCoursesType } from '../../../api/types/reports/education/courses/report-courses.type';
import dateFormat from '../../../utils/date-format';
import { getCellForCourseStatus } from '../../programs/program/courses/operations/get-cell-for-course-status';
import generateAndDownloadExcelFile from '../../../component/excel/generate-and-download-excel-file';

export const handleExportCoursesToExcel = (
  coursesData: ReportCoursesType[],
) => {
  const fileName = 'רשימת קורסים';

  // Create header row
  const headers = [
    'שלוחה',
    'שם קורס',
    'שם נוסף',
    'שם תכנית',
    'תאריך התחלה',
    'סטטוס קורס',
    'מכסת שעות מקורית',
    'מכסת שעות עדכנית',
    'סך שעות ששובצו',
    'סך שעות שבוצעו',
    'אחוז נוכחות',
    'מספר תלמידים',
    'ציון סופי ממוצע',
    'מרצים',
    'הערות הקורס',
  ];

  // Create data rows
  const dataRows = coursesData.map((course) => {
    const firstProgram = course.programs?.[0];
    const programName = firstProgram
      ? `${firstProgram.abstractProgramName} - מחזור ${firstProgram.annualSerialProgramNumber} - ${firstProgram.programStartYear}`
      : '';

    const statusCell = getCellForCourseStatus(course.status);
    const statusText = statusCell.content || '';

    const lecturers =
      course.lecturers?.map((l) => `${l.firstName} ${l.lastName}`).join(', ') ||
      '';

    return [
      course.branchName || '',
      course.courseName || '',
      course.additionalCourseName || '',
      programName,
      course.courseStartDate
        ? dateFormat.displayFormatDate(course.courseStartDate)
        : 'טרם שובצו הרצאות',
      statusText,
      course.courseHours?.toString() || '',
      course.capacityHours?.toString() || '',
      course.scheduledHours?.toString() || '',
      course.hoursActuallyWorked?.toString() || '',
      course.attendancePercentage?.toString() || '',
      course.studentNumber?.toString() || '',
      course.averageFinalGrade?.toString() || '',
      lecturers,
      course.courseNotes || '',
    ];
  });

  // Combine headers and data
  const excelData = [headers, ...dataRows];

  // Generate and download
  generateAndDownloadExcelFile(excelData);
};
